import { createApiFetcher, createApiPoster } from 'src/utils/ApiUtils';
import { ApplicationLicenseResponse, IAgreement } from 'src/shared/types/Agreement';

const fetchData = createApiFetcher('agreements/');
const postData = createApiPoster('agreements/');

export const getAllActiveAgreements = (): Promise<IAgreement[]> => fetchData<IAgreement[]>('active');

export const getAgreementById = (id: number): Promise<IAgreement> => fetchData<IAgreement>('', { agreementId: id });

export const getAgreementsToAccept = (): Promise<IAgreement[]> => fetchData<IAgreement[]>('accept');

export const respondAgreement = (response: ApplicationLicenseResponse): Promise<any> => postData('respond', response);
